import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromReducer from '@app/store/reducers/bus-terminals.reducer';
import { BusTerminalsState } from '@app/store/reducers/bus-terminals.reducer';

export const busTerminalsState = createFeatureSelector<BusTerminalsState>('busTerminals');

export const selectBusTerminalsEntities = createSelector(
  busTerminalsState,
  fromReducer.selectEntities
);
